import { theme } from '../../theme';
import { ROSTER } from '../Roster/tokens';

export const USAGE = {
  font: ROSTER.font,
  ink: ROSTER.ink,
  muted: ROSTER.muted,
  surface: ROSTER.surface,
  cardBg: ROSTER.cardBg,
  divider: ROSTER.border,
  border: ROSTER.border,
  primary: theme.palette.primary.main,
  primaryDark: theme.palette.primary.dark,
  primaryContrast: '#FFFFFF',
  indigo50: '#EFEFFA',
  indigo200: '#B9B9E6',
  hoverBg: ROSTER.hoverBg,
  tagGrey: { bg: '#EBEBEF', fg: '#4A4A5F' },
  tagIndigo: { bg: '#EFEFFA', fg: theme.palette.primary.main },
  title: { size: 32, weight: 700, lineHeight: '40px', letterSpacing: '-0.5px' },
  statValue: { size: 32, weight: 800, lineHeight: '40px', letterSpacing: '-0.5px' },
  label: { size: 12, weight: 700, lineHeight: '16px', letterSpacing: '1px' },
  body: { size: 16, weight: 400, lineHeight: '24px' },
  control: { height: 40, radius: 8 },
  card: { radius: 12, padding: 24 },
  chart: { height: 140, bar: 28 },
  columns: { narrow: 96, standard: 112, wide: 152, print: 80 },
  printRowsPerPage: 12,
  smallCaseload: 10,
} as const;
